window.initMasonryAnimation ?? (() => {
    window.initMasonryAnimation = (section_id) => {

        function animateCountUp(el, duration = 2000) {
            const target = parseInt(el.textContent.replace(/,/g, ''), 10);
            let start = 0;
            const startTime = performance.now();

            el.textContent = 0;

            function update(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);

                const value = Math.floor(progress * target);
                el.textContent = value.toLocaleString(); //.toLocaleString();

                if (progress < 1) {
                    requestAnimationFrame(update);
                }
            }

            requestAnimationFrame(update);
        }

        const counterObserver = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animateCountUp(entry.target);
                    obs.unobserve(entry.target);
                }
            });
        }, {
            threshold: 1
        });

        document.querySelectorAll(`section#shopify-section-${section_id} .count`).forEach(el => {
            counterObserver.observe(el);
        });

        const graph = document.querySelector(`section#shopify-section-${section_id} .masonry-panel-graph`);

        const graphObserver = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                    obs.unobserve(entry.target);
                }
            });
        }, {
            threshold: 1
        });

        graphObserver.observe(graph);
    }
  
})();